// src/components/Dashboard.jsx
import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import EntryList from "./EntryList";
// import Overrides from "./Overrides";
import CounterpartyGrid from "./CounterpartyGrid";
import Holdings from "./Holdings";

const Dashboard = ({ userId }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", gap: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={selectedTab} onChange={handleTabChange}>
          <Tab label="Entry List" />
          <Tab label="Holdings" />
          {/* <Tab label="Overrides" /> */}
          <Tab label="Counterparties" />
        </Tabs>
      </Box>

      {selectedTab === 0 && (
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <EntryList userId={userId} />
        </Box>
      )}

      {selectedTab === 1 && (
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <Holdings userId={userId} />
        </Box>
      )}

      {selectedTab === 2 && (
        //   <Box sx={{ flex: 1, minHeight: 0 }}>
        //     <Overrides userId={userId} />
        //   </Box>
        // )}

        // {selectedTab === 3 && (
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <CounterpartyGrid userId={userId} />
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
